/**
 * Created by vladislav on 07.07.20.
 */

const Scramble = function (...args) {
    WordGame.apply(this, args);

    this.counter.registerStage(0, this.keypad.fall.bind(this.keypad));
    this.counter.registerStage(5, CoinBlock.process);
    this.counter.registerStage(10, this.keypad.slide.bind(this.keypad));
    this.counter.registerStage(20, this.shuffle.bind(this));
    this.counter.registerStage(25, this.keypad.collectLeftMagnifiers.bind(this.keypad));
    this.counter.registerStage(30, this.keypad.processMagnifiers.bind(this.keypad));
    this.counter.registerStage(40, this.addPendingBonusBlocks.bind(this));
    this.counter.registerStage(50, this.updateCurrentHighlighter.bind(this));
};

Game = Scramble;

Scramble.prototype = Object.create(WordGame.prototype);
Scramble.prototype.constructor = Scramble;

Scramble.prototype.showScreen = function (f, silent) {
    cleverapps.focusManager.compound(f, [
        function (f) {
            this.board.showUp(f, silent);
        }.bind(this),

        function (f) {
            this.keypad.showUp(f, silent);
        }.bind(this)
    ]);
};

Scramble.prototype.calculatePendingBonusBlocks = function () {
    if (cleverapps.flags.bonusBlocksDisabled) {
        return 0;
    }

    if (this.keypad.words.length === 0) {
        return 0;
    }

    const openedWords = this.board.words.length - this.keypad.words.length;

    if (this.level.isBonusRound() || this.level.isBonus()) {
        return Math.floor(Math.random() * 3) + 1;
    }

    return openedWords === 1 || openedWords % 5 === 0;
};

Scramble.prototype.addPendingBonusBlocks = function () {
    if (this.pendingBonusBlocks > 0) {
        const delay = this.level.isBonusRound() || this.level.isBonus() ? 20 : 100;
        for (let i = 0; i < this.pendingBonusBlocks; i++) {
            this.counter.setTimeout(() => {
                this.keypad.addRandomBonus();
            }, i * delay + Math.random() * delay);
        }

        this.pendingBonusBlocks = 0;
    }
};

Scramble.prototype.updateCurrentHighlighter = function () {
    this.currentHighlighter.update();
};

Scramble.prototype.shuffle = function () {
    if (!this.keypad.getExistedWords().length && this.keypad.words.length > 0) {
        this.keypad.shuffle();
    }
};

Scramble.prototype.getInfo = function () {
    const info = WordGame.prototype.getInfo.call(this);
    info.hintBoosters = this.keypad.getMagnifiers();
    info.highlightBooster = this.currentHighlighter.isActive();
    info.keypad = this.keypad.getState();
    info.easy = this.keypad.easy;
    return info;
};